import { render, staticRenderFns } from "./postTitleBlock.vue?vue&type=template&id=58344001&scoped=true"
import script from "./postTitleBlock.vue?vue&type=script&lang=js"
export * from "./postTitleBlock.vue?vue&type=script&lang=js"
import style0 from "./postTitleBlock.vue?vue&type=style&index=0&id=58344001&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58344001",
  null
  
)

export default component.exports